module.exports = __webpack_public_path__ + "media/images/new/icons/instagram-5ad3a521be9c59710faf6f06147dae78.png";